import { render, staticRenderFns } from "./AddOrderTask.vue?vue&type=template&id=477ab5b0&"
import script from "./AddOrderTask.vue?vue&type=script&lang=js&"
export * from "./AddOrderTask.vue?vue&type=script&lang=js&"
import style0 from "./AddOrderTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports